import { Grid, Tab, Tabs } from '@mui/material';
import React, { useEffect } from 'react'
import { Link, Switch, Route } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { IntermediateGlobalLoading } from '../../../Component/Common/Components/Loading/IntermediateGlobalLoading';
import { MDBox } from '../../../Component/Common/Components/MDBox';
import { MDTypography } from '../../../Component/Common/Components/MDTypography';
import { useRouteMatch } from '../../../Helpers/RouteMatcher';
import { VerificationCompanyAtom } from '../../../State/VerificationCompany.Atom';
import { Contacts } from '../Contacts/Contacts';
import { CompanyDetails } from './CompanyDetails';
import { ReferredBy } from './ReferredBy';

export const DetailsBase = () => {

    const [company] = useRecoilState(VerificationCompanyAtom);

    useEffect(() => {
    }, [company.vaClientId])

    const routes = [
        "/company/details/company",
        "/company/details/contacts",
        "/company/details/refferedBy",
    ]

    const routeMatch = useRouteMatch(routes);
    const currentTab = routeMatch?.path;
    
    if(company.vaClientId === -1)
    {
        return (<IntermediateGlobalLoading/>);
    }
    else{
        return (
            <>
                <MDBox style={{ padding: "10px" }}>
                    <MDTypography variant='h4' fontWeight='bold' style={{ paddingBottom: "15px" }}>
                        Details
                    </MDTypography>
                </MDBox>
                <Grid container>
                    <Grid item xs={12}>
                        <Tabs value={currentTab} aria-label="Tabs" centered>
                            <Tab label="Company Details" value={routes[0]} to={routes[0]} component={Link} />
                            {company.vaClientId > 0 && <Tab label="Contacts" value={routes[1]} to={routes[1]} component={Link} />}
                            {company.vaClientId > 0 && <Tab label="Referred By" value={routes[2]} to={routes[2]} component={Link} />}
                        </Tabs>
                    </Grid>
                    <Grid item xs={12} mt={1}>
                        <Switch>
                            <Route path={routes[0]}>
                                <CompanyDetails />
                            </Route>
                            <Route path={routes[1]}>
                                <Contacts />
                            </Route>
                            <Route path={routes[2]}>
                                <ReferredBy />
                            </Route>
                        </Switch>
                    </Grid>
                </Grid>
            </>
        );
    }
}
